import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of as rxOf } from "rxjs/observable/of";
import { concatMap, map, catchError } from "rxjs/operators";
import { RenderContext } from "../webgl/webgl-context";
import { PngDecoder } from "./png-decoder";
var Texture = (function () {
    function Texture() {
        this.initialised = false;
    }
    Texture.prototype.init = function (gl, image) {
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, image.width, image.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, image.data);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        this.initialised = true;
    };
    ;
    return Texture;
}());
export { Texture };
;
var TextureLoader = (function () {
    function TextureLoader(http_client_, gl_, decoder_) {
        this.http_client_ = http_client_;
        this.gl_ = gl_;
        this.decoder_ = decoder_;
        this.texture_cache_ = {};
    }
    ;
    TextureLoader.prototype.loadTexture = function (file_name) {
        var _this = this;
        var texture = this.texture_cache_[file_name];
        if (texture) {
            return rxOf(texture);
        }
        var url = "texture/" + file_name;
        this.http_client_.get(url, { responseType: "blob" })
            .pipe(concatMap(function (blob) { return _this.decoder_.decode(blob); }), map(function (image) {
            var texture = new Texture();
            texture.init(_this.gl_.context, image);
            return texture;
        }), catchError(this.handleError));
    };
    ;
    TextureLoader.prototype.handleError = function (err) {
        return rxOf(new Texture());
    };
    ;
    TextureLoader.decorators = [
        { type: Injectable },
    ];
    TextureLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: RenderContext, },
        { type: PngDecoder, },
    ]; };
    return TextureLoader;
}());
export { TextureLoader };
;
//# sourceMappingURL=texture-loader.js.map